export const  declineNumber = function (number, singular, pluralFew, pluralMany) {
    // Check if the number is an integer and non-negative
    if (!Number.isInteger(number) || number < 0) {
        return "Invalid number";
    }

    // Polish declension rules
    if (number === 1) {
        return `${number} ${singular}`;
    } else if (number % 10 >= 2 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20)) {
        return `${number} ${pluralFew}`;
    } else {
        return `${number} ${pluralMany}`;
    }
}
